<template>
  <div class="outer" :style="outerStyle">
    <div class="inner" :style="innerStyle"></div>
  </div>
</template>

<script>
export default {
  name: "progress-bar",
  props: {
    max: {
      type: [Number, String],
      required: true
    },
    current: {
      type: [Number, String],
      required: true
    },
    backgroundColor: {
      type: String,
      required: false,
      default: '#2D2D2D'
    },
    barColor: {
      type: String,
      required: false,
      default: '#F4F4F4'
    }
  },
  computed: {
    currentPercent() {
      return this.current / this.max * 100;
    },
    outerStyle() {
      return {
        background: this.backgroundColor
      }
    },
    innerStyle() {
      return {
        width: `${this.currentPercent}%`,
        background: this.barColor
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../styles/main.styl'

.outer {
  background: color-light-grey
  width: 100%;
  height: 7px;
  border-radius: 4px;
  margin: 15px 0;
  overflow: hidden;
}

.inner {
  background: primary-color-red
  height: 100%;
  border-radius: 4px;
}
</style>
